import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { loadFilters } from '@/utils/filtersStorage';
import { SEOSegmentationFilterInput } from '@/__generated__/globalTypes';
import { MultiSelectPills } from './MultiSelectPills';

type PreferencesType = Pick<
  SEOSegmentationFilterInput,
  'comfortableWithPets' | 'hasCar' | 'nonSmoker'
>;

interface PreferencesProps {
  setPreferencesObject: Dispatch<SetStateAction<PreferencesType>>;
}

const Preferences = ({ setPreferencesObject }: PreferencesProps) => {
  const localStorageFilters = loadFilters();
  const COMFORTABLE_WITH_PETS = 'COMFORTABLE_WITH_PETS';
  const HAS_CAR = 'HAS_CAR';
  const NON_SMOKER = 'NON_SMOKER';
  const preferenceOptions = [
    { label: 'Comfortable with pets', value: COMFORTABLE_WITH_PETS },
    { label: 'Has own transportation', value: HAS_CAR },
    { label: 'Non-smoker', value: NON_SMOKER },
  ];

  const [preferencesList, setPreferencesList] = useState<string[]>([]);

  // check if any preference filters are currently applied from local storage
  useEffect(() => {
    const localStoragePreferencesFilters: SEOSegmentationFilterInput = {
      comfortableWithPets: false,
      hasCar: false,
      nonSmoker: false,
    };
    const currentPreferencesList: string[] = [];

    if (localStorageFilters?.comfortableWithPets) {
      localStoragePreferencesFilters.comfortableWithPets = true;
      currentPreferencesList.push(COMFORTABLE_WITH_PETS);
    }
    if (localStorageFilters?.hasCar) {
      localStoragePreferencesFilters.hasCar = true;
      currentPreferencesList.push(HAS_CAR);
    }
    if (localStorageFilters?.nonSmoker) {
      localStoragePreferencesFilters.nonSmoker = true;
      currentPreferencesList.push(NON_SMOKER);
    }

    setPreferencesObject(localStoragePreferencesFilters);
    setPreferencesList(currentPreferencesList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnChangeEvent = (values: string[]) => {
    const preferencesFilters: SEOSegmentationFilterInput = {
      comfortableWithPets: false,
      hasCar: false,
      nonSmoker: false,
    };

    values.forEach((skill: string) => {
      switch (skill) {
        case COMFORTABLE_WITH_PETS:
          preferencesFilters.comfortableWithPets = true;
          break;
        case HAS_CAR:
          preferencesFilters.hasCar = true;
          break;
        case NON_SMOKER:
          preferencesFilters.nonSmoker = true;
          break;
        default:
        // do nothing
      }
    });

    setPreferencesObject(preferencesFilters);
    setPreferencesList(values);
  };

  return (
    <MultiSelectPills
      sectionName="Preferences"
      handleOnChangeEvent={handleOnChangeEvent}
      pillOptions={preferenceOptions}
      category="PREFERENCES"
      selectedValues={preferencesList}
    />
  );
};

export { Preferences };
